<template>
  <div class="cml-input-maxlength">
    <el-divider class="cml-divider" id="cml-divider" content-position="center">{{ statusName }}单个赠品</el-divider>
    <el-form
      :disabled="formDisabled"
      :model="formData"
      :rules="rules"
      ref="formData"
      label-width="300px"
    >
      <el-form-item label="供应商" prop="supplierCode">
        <el-input v-if="!['2', '1'].includes(this.$store.getters.userSelf.user.adminType) || status !== 'add'" disabled v-model.trim="formData.supplierName" />
        <SupplierSelect
          v-else
          :disabled="!['2', '1'].includes(this.$store.getters.userSelf.user.adminType) || status !== 'add'"
          supplierType="GIFT_MATERIAL"
          :value="formData.supplierCode"
          @change-emit="supplierChange"
        />
      </el-form-item>
      <el-form-item label="产品名称" prop="productName">
        <el-input
          v-model.trim="formData.productName"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="产品类别" prop="productType">
        <DictSelect
          type="gift_product_type"
          :value="formData.productType"
          @change-emit="productTypeChange"
        />
      </el-form-item>
      <el-form-item v-if="productCategoryOptions.length > 0" id="img-box" label="产品品类" prop="productCategory">
        <el-select
          v-model="formData.productCategory"
          filterable
          clearable
          size="mini"
        >
          <el-option
            v-for="item in productCategoryOptions"
            :key="item.id"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="主图片" class="img-box" id="img-box2" required prop="mainImage">
        <UploadImage
          v-if="showUploadImage"
          ref="uploadImage"
          :disabled="formDisabled"
          :status="status"
          :imgUrl="formData.mainImage"
          @img-change="mainImageChange"
        />
      </el-form-item>
      <el-form-item label="材质" prop="material">
        <el-input
          v-model.trim="formData.material"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="尺寸" prop="size">
        <el-input
          v-model.trim="formData.size"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="工艺" prop="craft">
        <el-input
          v-model.trim="formData.craft"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="是否有专利" prop="havePatent">
        <DictSelect
          type="cml_common_whether"
          :value="formData.havePatent"
          @change-emit="value => (formData.havePatent = value)"
        />
      </el-form-item>
      <el-form-item label="样品的打样时间" prop="proofingTime">
        <CustomNumInput
          :value="formData.proofingTime"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.proofingTime = val)"
        />
        天内
      </el-form-item>
      <el-form-item label="样品的大货时间" prop="deliveryTime">
        <CustomNumInput
          :value="formData.deliveryTime"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.deliveryTime = val)"
        />
        天内
      </el-form-item>
      <el-form-item label="正式订单的最低起订量（个）" prop="minNum">
        <CustomNumInput
          :value="formData.minNum"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.minNum = val)"
        />
      </el-form-item>
      <el-form-item label="预估含税单价（元/个）" prop="price">
        <CustomNumInput
          :value="formData.price"
          :maxlength="7"
          :isNegativeFloat="true"
          @change-emit="val => (formData.price = val)"
        />
      </el-form-item>
      <el-form-item label="是否为我司生产过此样品的大货" prop="haveMassProduction">
        <DictSelect
          type="cml_common_whether"
          :value="formData.haveMassProduction"
          @change-emit="haveMassProductionChange"
        />
      </el-form-item>
      <el-form-item v-if="formData.haveMassProduction === 'YES'" label="已使用品牌" prop="brandsUsed">
        <el-input
          v-model.trim="formData.brandsUsed"
          :maxlength="100"
          show-word-limit
          placeholder="多个品牌请用逗号隔开"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="formData.haveMassProduction === 'NO'"
        label="开发进度"
        prop="developmentProgress"
      >
        <el-input
          v-model.trim="formData.developmentProgress"
          :maxlength="maxlength"
          show-word-limit
          placeholder="请说明开发进度"
        ></el-input>
      </el-form-item>
      <el-form-item id="editor-box" label="产品详情" prop="information">
        <TextareaEditor :disabled="formDisabled" ref="textareaEditor" />
      </el-form-item>
      <el-form-item label="附件">
        <el-row class="fujian-box">
          <el-col :span="10" v-for="(item, index) in uploadBtns" :key="index">
            <UploadFile
              ref="uploadRef"
              :btnName="item.name"
              :multiple="item.multiple"
              :maxSize="100"
              :excelFileExtend="'.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.jpg,.png,.jpeg'"
              :disabled="formDisabled"
            />
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    
    <span
      v-if="!formDisabled && status !== 'verify'"
      style="margin: 20px 0 50px 300px"
    >
      <el-button size="medium" :loading="saveLoading" @click="saveBtn"
        >保存草稿</el-button
      >
      <el-button
        type="primary"
        size="medium"
        style="margin-left: 50px"
        :loading="saveLoading"
        @click="submitBtn"
        >提交审核</el-button
      >
    </span>
    <SubmitDialog
      :dialogVisible="dialogVisible"
      @create-again="createAgain"
      @to-sample-page="toSamplePage"
    />

    <!-- 审核 -->
    <VerifyComponent
      ref="verifyComponent"
      :status="status"
      :statusName="statusName"
      :saveLoading="saveLoading"
      @verify-btn="verifyBtn"
    />
  </div>
</template>
<script>
import SupplierSelect from '@/components/SupplierSelect';
import DictSelect from '@/components/DictSelect';
import UploadImage from '@/components/Upload/UploadImage.vue';
import CustomNumInput from '@/components/CustomNumInput';
import TextareaEditor from '@/components/TextareaEditor';
import VerifyComponent from '../sample-component/VerifyComponent.vue';
import SubmitDialog from '../sample-component/SubmitDialog.vue';
import UploadFile from '@/components/Upload/UploadFile.vue';
import { cloneDeep } from 'lodash';
import sampleCreate from '@/mixins/sampleCreate';
import { mapGetters } from 'vuex';

export default {
  name: 'publish-gift-sample',
  components: {
    SupplierSelect,
    DictSelect,
    UploadImage,
    CustomNumInput,
    TextareaEditor,
    VerifyComponent,
    SubmitDialog,
    UploadFile
  },
  mixins: [sampleCreate],
  data() {
    const mainImageValid = (rule, value, callback) => {
      if (!value) {
        this.pageScrollToTop('img-box');
        callback(new Error('请选择主图片'));
      } else {
        callback();
      }
    };
    return {
      id: '',
      row: { id: '' },
      formData: {
        sampleId: '',
        id: '',
        supplierCode: '',  // 供应商code
        supplierName: '',  // 供应商name
        productName: '',  // 产品名称
        productType: '',  // 产品类别
        productCategory: '', // 产品品类
        mainImage: '', // 主图片
        material: '', // 材质
        size: '', // 尺寸
        craft: '', // 工艺
        havePatent: '',   // 是否有专利
        proofingTime: '',  // 样品的打样时间
        deliveryTime: '',  // 样品的大货时间
        minNum: '',  // 正式订单的最低起订量（个）
        price: '',  // 预估含税单价（元/个）
        haveMassProduction: '',  // 是否为我司生产过此样品的大货
        developmentProgress: '', // 开发进度
        brandsUsed: '',  // 已使用品牌
        information: '',  // 产品详情
      },
      productCategoryOptions: [],
      rules: {
        supplierCode: [{ required: true, message: '请选择供应商', trigger: 'change' }],
        productName: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        productType: [{ required: true, message: '请选择产品类别', trigger: 'change' }],
        productCategory: [{ required: true, message: '请选择产品品类', trigger: 'change' }],
        price: [{ required: true, message: '请输入预估含税单价', trigger: 'blur' }],
        mainImage: [{ validator: mainImageValid, trigger: 'blur' }],
        material: [{ required: true, message: '请输入材质', trigger: 'blur' }],
        size: [{ required: true, message: '请输入尺寸', trigger: 'blur' }],
        craft: [{ required: true, message: '请输入工艺', trigger: 'blur' }],
        havePatent: [{ required: true, message: '请选择是否有专利', trigger: 'change' }],
        minNum: [{required: true, message: '请输入正式订单的最低起订量 （个）', trigger: 'blur'}],
        haveMassProduction: [{required: true, message: '请选择是否为我司生产过此样品的大货', trigger: 'change'}],
        deliveryTime: [{ required: true, message: '请输入样品的大货时间', trigger: 'blur' }],
        proofingTime: [{ required: true, message: '请输入样品的打样时间', trigger: 'blur' }],
        information: [{ required: true, message: '请输入产品详情', trigger: 'blur' }],
      },
      saveLoading: false,
      status: 'add',
      statusName: '新增',
      maxlength: 30,
      formDisabled: false,
      dialogVisible: false,
      showUploadImage: true,
      uploadBtns: [
        { name: '包装刀版文件', multiple: false },
        { name: '专利证书（若有，则提供）', multiple: false },
        { name: '相关质量体系证书', multiple: false },
        { name: '所用主要材质的安全证明（外检报告，MSDS）', multiple: false },
        { name: '产品适用的国家标准、行业标准或者企业标准', multiple: false },
      ],
      fileType: [
        'PACKAGING_DOCUMENT',
        'PATENTS_CREDENTIAL',
        'QUALITY_CREDENTIAL',
        'MSDS',
        'PRODUCT_STANDARD'
      ],
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.checkQueryParams(vm);
    });
  },
  mounted() {
    const { code, name } = this.$store.getters.userSupplier;
    if(code) {
      this.formData.supplierCode = code;
      this.formData.supplierName = name;
    }
  },
  computed: {
    ...mapGetters(['allDictListData'])
  },
  methods: {
    getDetail() {
      this.$http.sampleManage
        .getGIFTSample(this.id)
        .then(result => {
          for (let i in this.formData) {
            this.formData[i] = result.data[i];
          }
          this.formData.sampleId = this.row.id;
          // 产品类别
          this.productTypeChange(result.data.productType);
          this.formData.productCategory = result.data.productCategory;
          // 设置textarea内容
          this.$refs.textareaEditor.setHtml(result.data.information);
          // 附件
          if(result.data.sampleAttachmentVOs && result.data.sampleAttachmentVOs.length > 0) {
            this.$refs.uploadRef.map((item, index) => {
              const type = this.fileType[index];
              item.fileList = result.data.sampleAttachmentVOs
                .filter(item => item.type === type)
                .map(item => {
                  return {
                    fileName: item.name,
                    fileUrl: item.url,
                  };
                });
            });
          }
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    productTypeChange(val) {
      const categoryData = this.allDictListData.data.gift_product_category
      this.productCategoryOptions = categoryData.filter(item => item.value.split('_')[0] === val)
      this.formData.productType = val;
      this.formData.productCategory = '';
    },
    haveMassProductionChange(val) {
      this.formData.haveMassProduction = val;
      this.formData.brandsUsed = '';
      this.formData.developmentProgress = '';
    },
    checkParams() {
      let state = true;
      if(!this.formData.mainImage) {
        this.$message.error('请选择主图片');
        state = false;
        return;
      }
      if(this.formData.deliveryTime === '0') {
        this.$message.error('样品的大货时间必须大于0');
        state = false;
        return;
      }
      if(this.formData.proofingTime === '0') {
        this.$message.error('样品的打样时间必须大于0');
        state = false;
        return;
      }
      if(this.formData.minNum === '0') {
        this.$message.error('正式订单的最低起订量必须大于0');
        state = false;
        return;
      }
      if(this.formData.price === '0') {
        this.$message.error('预估含税单价必须大于0');
        state = false;
        return;
      }
      const { imgUrls, text } = this.$refs.textareaEditor.getHtml();
      if(imgUrls.length > 20) {
        this.$message.error('产品详情最多可以上传20张图片');
        state = false;
        return;
      }
      if(text.length > 5000) {
        this.$message.error('产品详情最多可以输入5000个字符');
        state = false;
        return;
      }
      return state;
    },
    saveBtn(val) {
      const { allHtml } = this.$refs.textareaEditor.getHtml();
      this.formData.information = allHtml.trim();
      this.$refs.formData.validate(async valid => {
        if(valid) {
          if(this.checkParams()) {
            let params = cloneDeep(this.formData);
            const $url = ['add', 'copy'].includes(this.status) ? 'createGiftSample' : 'updateGiftSample';
            if(['add', 'copy'].includes(this.status)) {
              delete params.id;
              delete params.sampleId;
            }
            // 附件
            const AttachmentCmdList = ['add', 'copy'].includes(this.status) ? 'createSampleAttachmentCmdList' : 'updateSampleAttachmentCmdList';
            params[AttachmentCmdList] = this.$refs.uploadRef.reduce((prev, cur, index) => {
              const file = cur.fileList;
              if (file.length > 0) {
                const fileName = file[0].fileName.substring(
                  file[0].fileName.lastIndexOf('.'),
                );
                prev.push({
                  name: this.uploadBtns[index].name + fileName,
                  sampleId: ['add', 'copy'].includes(this.status) ? '' : this.formData.sampleId,
                  type: this.fileType[index],
                  url: file[0].fileUrl,
                });
              }
              return prev;
            }, []);
            try {
              const msg = await this.saveParams($url, params);
              // 提交
              if(val === 'submit') {
                this.$http.sampleManage
                  .batchSubmitSample([this.row.id])
                  .then(result => {
                    if(result.data.failNum > 0) {
                      this.$message.error(
                        result.data.failResultList[0].code +
                          result.data.failResultList[0].msg,
                      );
                    } else {
                      this.dialogVisible = true;
                    }
                  })
                  .catch(err => {
                    this.$message.error(err.msg);
                  })
                  .finally(() => {
                    this.saveLoading = false;
                  });
              } else {
                if(['add', 'copy', 'update'].includes(this.status)) {
                  this.$message.success(msg);
                  this.toSamplePage('submitSuccessToHistoryTab1');
                } else if (this.status === 'verify') {
                  // 审核
                  const params = {
                    ...this.$refs.verifyComponent.verifyFormData,
                  };
                  params.sampleId = this.row.id;
                  this.saveLoading = true;
                  this.$http.sampleManage
                    .createSampleCheck(params)
                    .then(result => {
                      this.$message.success(result.msg);
                      this.toSamplePage(
                        'toListTab1',
                        'sample-manage/verify-sample',
                        '审核样品',
                      );
                    })
                    .catch(err => {
                      this.$message.error(err.msg);
                    })
                    .finally(() => {
                      this.saveLoading = false;
                    });
                }
              }
            } catch (err) {
              this.$message.error(err);
            }
          }
        } else {
          this.$message.error('必填项不能为空，请认真检查哦！');
          this.pageScrollToTop();
          return false;
        }
      });
    },
    saveParams($url, params) {
      return new Promise((reslove, reject) => {
        this.saveLoading = true;
        this.$http.sampleManage[$url](params)
          .then(result => {
            // code=-1，错误提示
            if(result.data.code && result.data.code == -1) {
              reject(result.data.msg);
              return;
            }
            if(['add', 'copy'].includes(this.status)) {
              this.row.id = result.data;
            }
            reslove(result.msg);
          })
          .catch(err => {
            reject(err.msg);
          })
          .finally(() => {
            this.saveLoading = false;
          });
      });
    },
    // 提交
    submitBtn () {
      this.saveBtn('submit');
    },
    resetForm() {
      this.showUploadImage = false;
      this.$nextTick(() => {
        this.showUploadImage = true;
      });
      this.status = 'add';
      this.statusName = '新增';
      this.row = { id: '' };
      this.$refs.formData.resetFields();
      Object.keys(this.formData).map(item => {
        this.formData[item] = undefined
      })
      this.$refs.uploadRef.map(item => {
        item.fileList = [];
      });
      this.$refs.textareaEditor.clear();
      const { code, name } = this.$store.getters.userSupplier;
      this.formData.supplierCode = code;
      this.formData.supplierName = name;
    },
    mainImageChange(val) {
      this.formData.mainImage = val;
      if(val) {
        this.$refs.formData.clearValidate('mainImage');
      } else {
        this.$refs.formData.validateField('mainImage');
      }
    },
    supplierChange(val, name) {
      this.formData.supplierCode = val;
      this.formData.supplierName = name;
    },
  },
};
</script>
<style lang="less" scoped>
.fujian-box {
  position: relative;
  width: 798px;
  height: 135px;
  & > div {
    margin: 0 10px 15px 0;
  }
  &::after {
    position: absolute;
    left: -125px;
    top: 30px;
    content: '（支持DOC、DOCX、PDF、XLS、XLSX、PPT、PPTX、JPG、PNG、JPEG格式文件）';
    width: 130px;
    font-size: 12px;
    line-height: 16px;
  }
}
</style>